<template>
    <div class="Details">
    <section>
        <div class="x">
            <div class="box" v-if="model.prompt">
                {{  model }}
                <b-tabs class="block">
                    <b-tab-item>
                        <template #header>
                            <h4 class="title is-4">Prompt</h4>
                        </template>

                        <div class="columns is-multiline" v-if="model.prompt">
                            <div class="column is-one-third">
                            
                        <b-field label="Model base">
                            <b-select expanded 
                            @input="runOrCreatePrompt"
                            v-model="model.prompt.modelBase" size="" placeholder="Select a model base">
                                    <option value="ada">GPT-3 Ada</option>
                                    <option value="curie">GPT-3 Curie</option>
                                    <option value="davinci">GPT-3 Davinci</option>
                                    <option value="bloom">Bloom 173B</option>
                            </b-select>
                        </b-field>

                        </div>
                        <div class="column is-one-third">

                        <b-field label="Temperature">
                            <b-slider expanded 
                            @input="runOrCreatePrompt"
                            size="" :min="0" :max="2.0" v-model="model.prompt.temperature" ticks></b-slider>
                        </b-field>

                        </div>
                        <div class="column is-one-third">

                        <b-field label="Stop Sequence">
                            <b-taginput
                            @input="runOrCreatePrompt"
                            v-model="model.prompt.stopSequence"
                            placeholder="Add a tag"
                            aria-close-label="Delete this tag">
                            </b-taginput>
                            
                        </b-field>
                        </div>
                        </div>
                        <b-field label="Prompt" message="Use the tags {input} and {output}">
                        <b-input @input="runOrCreatePrompt" v-model="model.prompt.prompt" maxlength="200" type="textarea"></b-input>
                        </b-field>

                        <p>
                            {{  model.prompt.prompt }}
                            <!-- {{ model.prompt.prompt.replace("{input}", row.text)}}[completion] -->
                        </p>
                        <br>
            
                        <div class="columns is-multiline">
                            <div class="column is-half">
                                <b-field label="Input">
                                    <b-input @input="changeInput(row)" maxlength="500" v-model="row.text"  type="textarea"></b-input>
                                </b-field>
                            </div>
                            <div class="column is-3">
                                <b-field label="Output" v-if="project.type != 'classification'">
                                    <b-input @input="changeOutput(row)" v-model="row.label" maxlength="400" type="textarea"></b-input>
                                </b-field>
                            </div>
                            <div class="column is-3">
                                <b-field label="Generated Completion">
                                    <b-input v-model="row.model_prediction" maxlength="200" type="textarea"></b-input>
                                </b-field>
                                <b-button @click="completePromptGPT(row)" type="is-light" expanded>Generate</b-button>
                            </div>
                        </div>

                    </b-tab-item>
                </b-tabs>
                
            
              <br>
              
        </div>
        </div>
        
        
    </section>

    </div>
    
</template>
<script>
import ModalDataset from '@/components/DatasetIncrease.vue'
import ModalModel from '@/components/ModelCreateNew.vue'
import LabelsDefine from '@/components/LabelsDefine.vue'
import { isThenable } from '@sentry/utils';

   export default {
     props: ["project", "modelId", "projectDocuments", "projectDatasets", "currentUser", "filterId"],
     name: "Uploads",
     data: function() {
    return {
        
        isModalDatasetIncreaseOpen: false,
        isModalModelCreateOpen: false,
        row: {
            text: "hello world",
            label: "completion",
            model_prediction: "nothing yet"
        },
        prompt_template: null,
        temperature: 0.5,
        stopSequence: ["\\n", "#"],
        modelBase: "ada"
    }},
    components: {
      ModalDataset,
      ModalModel,
      LabelsDefine
    },
    computed: {
        model() {
          return this.$store.state.currentModel
      },
     },
     methods: {
        async completePromptGPT(row){
            const payload = {
                modelId: this.modelId,
                text: row.text,
                hub: true
            }
            
            
            const result = await this.$store.dispatch("getModelInference", payload);
            console.log(result)
            this.row.model_prediction = result
        },
        changeInput(row){
            return;
        },
        changeOutput(row){
            return;
        },
            
        generatePromptConfig(){
            
            return {
                prompt: this.model.prompt.prompt,
                temperature: this.model.prompt.temperature || this.temperature,
                stopSequence: this.model.prompt.stopSequence || this.stopSequence,
                modelBase: this.model.prompt.modelBase || this.modelBase
            }

        },
        async runOrCreatePrompt(){

            if (this.project.modelId == undefined){
            await this.createPrompt()
            } else {
            await this.updatePrompt()
            }

        },
        async updatePrompt(){
            this.$buefy.notification.open('Updating prompt...')
            const updateModel = {
                modelId: this.project.modelId,
                update: {
                    prompt: this.generatePromptConfig()
                }
            }

            console.log(updateModel)

            this.$store.dispatch("updateModel",
                updateModel
            );
            this.$buefy.notification.open('Done!')
        },
        async createPrompt(){

            this.$buefy.notification.open('Creating prompt...')
            
            const model = {
                type: 'prompt',
                projectId: this.project.id,
                datasetId: this.project.datasetId,
                prompt: this.generatePromptConfig()
            }

            var newDoc = this.$store.dispatch("createModel",
                model
            );

            newDoc.then(newModelId => {
                
                if(this.project.models != undefined){
                this.project.models.push(newModelId)
                } else {
                this.project.models = [newModelId]
                }

                const addModelToProject = {
                projectId: this.project.id,
                add: {
                    models: this.project.models,
                    modelId: newModelId
                }
                }
                this.$store.dispatch("addModelToProject",
                addModelToProject
                );

                this.$buefy.notification.open('Done!')
            })
            }
        
        },
        created() {
            this.$store.dispatch("currentModel", this.modelId);

            
            
        }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>